// get the set of month names for the actiuve language
import { useActiveLangStrings } from "./use-active-lang-strings";
export var useMonthNames = function () {
  var strings = useActiveLangStrings();
  var monthNames = strings.monthNames || 'January_February_March_April_May_June_July_August_September_October_November_December';
  return monthNames.split('_');
};